import getTiersForFeature from './getTiersForFeature';

function prepareGetUpgradeOptions(userFeatures) {
  return function (featureName) {
    const isNeedUpgrade = !(userFeatures?.[featureName]);
    const featureTiers = getTiersForFeature(featureName);

    return {
      isNeedUpgrade,
      tierToEnable: featureTiers[0],
    };
  };
}

export default prepareGetUpgradeOptions;
